import { PartnerConfig } from "src/app/core/interfaces/partner-config";

export const Partner: PartnerConfig = {
  id: 'test',
  title: {
    de: 'Sysbiz Test Portal [de]',
    it: 'Sysbiz Test Portal [it]',
    en: 'Sysbiz Test Portal [en]'
  },
  portalUrl: 'https://test-bs.systems.bz',
  apiUrl: 'https://test-bs-api.systems.bz',
  oldPortalUrl: 'https://test-bs.systems.bz/-/',
  jobServiceUrl: 'https://test-job.systems.bz/jobs',
  backlink: true,
  pathPrefix: '',
  bankingVersionCookie: { name: 'test-portal-version-banking', domain: '.systems.bz' },
  documentSignerVersionCookie: { name: 'test-portal-version-documentsigner', domain: '.systems.bz' },
  postboxVersionCookie: { name: 'test-portal-version-postbox', domain: '.systems.bz' },
  conservationVersionCookie: { name: 'test-portal-version-conservation', domain: '.systems.bz' },
  ssoRedirectPage: "https://sso.systems.bz/1bce3963-8e34-f011-a5f1-6045bd9b7d9c",
}

